import { useEffect, type RefObject, useCallback } from 'react'

export const useCloseFilterOnClickOutside = (
  popoverRef: RefObject<HTMLDivElement>,
  buttonRef: RefObject<HTMLButtonElement>,
  handlePopoverClose: () => void
) => {
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const isClickInsideCalendar = Array.from(
        document.querySelectorAll('[data-calendar="true"]')
      ).some((el) => el.contains(event.target as Node))

      const isClickInsideSelectOptions = Array.from(
        document.querySelectorAll('.mantine-Select-options')
      ).some((el) => el.contains(event.target as Node))

      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node) &&
        !isClickInsideCalendar &&
        !isClickInsideSelectOptions
      ) {
        handlePopoverClose()
      }
    },
    [popoverRef, buttonRef, handlePopoverClose]
  )

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [handleClickOutside])
}
